module.exports = __webpack_public_path__ + "img/draw_1.72c69409.jpg";